// 商行管理（查看详情--商行配置管理)
import React, { PureComponent } from 'react';
import { Form, Button, message, Table, Modal, Row, Col, Popconfirm, Select } from 'antd';
import { Space } from 'antd-v5';
import './device.less';
import { TEMPLATE_SOURCE_TYPE, TEMPLATE_TYPE } from '../../../label-template-management/index';
import {
  requestTagTemplateStallRelationList,
  requestTagTemplateList,
  requestTagTemplateStallRelationAdd,
  requestTagTemplateStallRelationRemove,
} from '../../../../state/request/tag';
import Preview from '../../../label-template-management/components/preview';

@Form.create()
class StallTemplateManage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showModal: false,
      dataList: [],
      tagTemplateList: [],
      selected: null,
      previewOpen: false,
      previewData: null,
    };
  }

  componentDidMount() {
    this.getTagTemplateList();
    this.getRelationList();
  }

  // 删除档口分组
  async deleteTemplateRelation(e, relationId) {
    e.preventDefault();
    const { stallId } = this.props;
    const resData = await requestTagTemplateStallRelationRemove({ relationId, stallId });
    const msg = '移除';
    if (resData.code === 200) {
      message.success(`${msg}成功`);
    }
    this.getRelationList();
  }

  async getTagTemplateList() {
    const res = await requestTagTemplateList();
    if (res?.code === 200) {
      this.setState({
        tagTemplateList: res.data.filter((item) => item.enable),
      });
    }
  }

  getRelationList = async () => {
    const { stallId } = this.props;
    this.setState({ loading: true });
    const res = await requestTagTemplateStallRelationList({ stallId });
    if (res?.code === 200) {
      this.setState({ loading: false, dataList: res.data || [] });
    }
  };

  async saveTemplateRelation() {
    const { selected } = this.state;
    const { stallId } = this.props;
    if (selected) {
      const res = await requestTagTemplateStallRelationAdd({
        templateId: selected,
        stallId,
      });
      const { code, msg } = res;
      this.setState({
        selected: null,
        showModal: false,
      });
      if (code === 200) {
        message.success('保存成功', 5);
        this.getRelationList();
      }
    } else {
      message.error('标签模板不能为空', 5);
    }
  }

  //新增、编辑Modal框
  showModal = (visible) => {
    this.setState({
      showModal: visible,
      selected: null,
    });
  };

  selectTemplate = (e) => {
    this.setState({
      selected: e,
    });
  };

  getPreviewTemplateData = () => {
    const { previewData } = this.state;
    try {
      return previewData ? JSON.parse(previewData.templateDetail) : {};
    } catch (error) {
      console.error('模板配置解析失败:', error);
      return {};
    }
  };

  render() {
    const { selected, loading, showModal, dataList, tagTemplateList, previewOpen } = this.state;
    const previewTemplateData = this.getPreviewTemplateData();
    const columns = [
      {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 100,
        render: (_, __, index) => {
          return index + 1;
        },
      },
      {
        title: '模板名称',
        dataIndex: 'templateName',
        key: 'templateName',
      },
      {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
        ellipsis: true,
      },
      {
        title: '类型',
        dataIndex: 'sourceType',
        key: 'sourceType',
        render: (_, record) => {
          const { sourceType } = record;
          const template = TEMPLATE_TYPE.find((item) => item.value === sourceType);
          return template ? template.label : '';
        },
      },
      {
        title: '操作',
        dataIndex: 'options',
        key: 'options',
        width: 140,
        render: (_, record) => {
          const { relationId } = record;
          return (
            <Space wrap>
              <a
                href='/'
                style={{ marginRight: 16 }}
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({ previewOpen: true, previewData: record });
                }}
              >
                <span>查看</span>
              </a>
              <Popconfirm
                title='是否确定移除'
                onConfirm={(e) => this.deleteTemplateRelation(e, relationId)}
                okText='确认'
                cancelText='取消'
                disabled={record.sourceType === TEMPLATE_SOURCE_TYPE.SYSTEM}
              >
                <a
                  href='/'
                  style={{
                    color:
                      record.sourceType === TEMPLATE_SOURCE_TYPE.SYSTEM
                        ? 'rgba(0, 0, 0, 0.25)'
                        : '#01b755',
                  }}
                >
                  <span>移除</span>
                </a>
              </Popconfirm>
            </Space>
          );
        },
      },
    ];
    return (
      <div className='deviceManagement'>
        <Row>
          <Col span={14} style={{ textAlign: 'left' }}>
            <Button type='primary' icon='plus' onClick={() => this.showModal(true)}>
              添加模板
            </Button>
          </Col>
        </Row>
        <Table dataSource={dataList} columns={columns} loading={loading} />
        <Modal
          title='添加标签模板'
          visible={showModal}
          onCancel={() => this.showModal(false)}
          footer={
            <Row style={{ textAlign: 'center' }}>
              <Button onClick={() => this.showModal(false)}>取消</Button>
              <Button
                type='primary'
                onClick={() => this.saveTemplateRelation()}
                style={{ marginLeft: '18px' }}
              >
                保存
              </Button>
            </Row>
          }
          width='450px'
          className='add-modal'
        >
          <Select
            style={{ width: '100%' }}
            placeholder='请选择配置'
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={selected}
            onChange={this.selectTemplate}
          >
            {tagTemplateList &&
              tagTemplateList.map((item) => (
                <Select.Option
                  title={`${item.templateName}${item.remark ? `-${item.remark}` : ''}`}
                  key={item.id}
                  value={item.id}
                >
                  {`${item.templateName}${item.remark ? `-${item.remark}` : ''}`}
                </Select.Option>
              ))}
          </Select>
        </Modal>
        <Modal
          title='模板预览'
          visible={previewOpen}
          destroyOnClose
          onOk={() => this.setState({ previewOpen: false })}
          onCancel={() => this.setState({ previewOpen: false })}
          footer={null}
          width={1000}
        >
          <div style={{ padding: '64px 0' }}>
            <Preview {...previewTemplateData} />
          </div>
        </Modal>
      </div>
    );
  }
}

export default StallTemplateManage;
